import moment from "moment";
export const dateformat = "yyyy/MM/DD";
export const dateMuiformat = "yyyy/MM/dd";
export const dateTimeMuiformat = "yyyy/MM/dd HH:mm";
export const dateTimeformat = "yyyy/MM/DD HH:mm";
export const dateTimeApiformat = "yyyy/MM/DD HH:mm";
export const dateFullMonthformat = "DD-MMM-yyyy";
export const dateTimeformatNew = "DD-MMM-yyyy HH:mm";
export const ApiDateTimeFormat = "yyyy-MM-DDTHH:mm:ss";
export const timeformat = "HH:mm";

export function MuiDateTimeToApi(params) {
  let date = moment(params).isValid()
    ? moment(params).format(ApiDateTimeFormat)
    : params;
  return date||null;
}
export function DateTimeApiToDateTimeString(params) {
  let date = moment(params).isValid()
    ? moment(params).format(dateTimeformat)
    : "";
  return date;
}
export function DateTimeApiToTimeString(params) {}
export function DateTimeStringToDateTimeApi(params) {}
export function TimeStringToDateTimeApi(params) {}
export const ToDateTimeApi = (datetimeortime) => {
  //For send .netCore api
  if (moment(datetimeortime).isValid()) {
    let datetime = moment(datetimeortime).format(dateTimeApiformat);
    return datetime;
  }
  //if onlytime
  var today = new Date();
  var dd = String(today.getDate()).padStart(2, "0");
  var mm = String(today.getMonth() + 1).padStart(2, "0"); //January is 0!
  var yyyy = today.getFullYear();

  today = yyyy + "-" + mm + "-" + dd + "T" + datetimeortime;
  if (moment(today).isValid()) {
    let datetime = moment(today).format(dateTimeApiformat);
    return datetime;
  }
  return null;
};
export function HookisvalidDate(data = [], fieldname = []) {
  let result = true;
  for (let idx = 0; idx < fieldname.length; idx++) {
      const el = fieldname[idx];
      if (data[el] && !moment(data[el]).isValid()) return false
  }
  return result;
}
export function ToDateText(params) {
  let date = moment(params).isValid() && params !== undefined
    ? moment(params).format(dateformat)
    : "";
  return date;
}
export function ToDateTimeTextOld(params) { //update 30-01-2022
  let date = moment(params).isValid() && params !== undefined
    ? moment(params).format(dateTimeformat)
    : "";
  return date;
}

export function ToDateTimeText(params) {
  let date = moment(params).isValid() && params !== undefined
    ? moment(params).format(dateTimeformatNew)
    : "";
  return date;
}
export function ToDateFullMonthText(params) {
  let date = moment(params).isValid() && params !== undefined
    ? moment(params).format(dateFullMonthformat)
    : "";
  return date;
}


export function checkDateRange(start, end) {
  // Parse the entries
  var startDate = moment(start);
  var endDate = moment(end);
  console.log(startDate,endDate)
  // Make sure they are valid
   if (isNaN(startDate)) {
     //alert("The start date provided is not valid, please enter a valid date.");
     return false;
  }
  if (isNaN(endDate)) {
      //alert("The end date provided is not valid, please enter a valid date.");
      return false;
  }
  // Check the date range, 86400000 is the number of milliseconds in one day
  var difference = (endDate - startDate) // (86400000 * 7);
  console.log(difference)
  if (difference < 0) {
      //alert("The start date must come before the end date.");
      return false;
  }
  // if (difference <= 1) {
  //     //alert("The range must be at least seven days apart.");
  //     return false;
  //  }
  return true;
}